export default ({ $auth, redirect, error, $RouteEnum }) => {
  if ($auth.isGuest) {
    redirect({ name: $RouteEnum.LOGIN });
  }

  if (!$auth.isTenantMember) {
    return error({ statusCode: 404, message: 'This page could not be found' });
  }
};
